import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal, GLOBAL_MODAL_TYPE, selectIsModalOpen } from 'state/constants'
import Modal, { ModalSize } from 'particles/Modal'

interface ExportModalProps {
    title: string
    description: string
    onConfirm: any
    confirmText: string
    cancelText: string
    modalType: GLOBAL_MODAL_TYPE.BANNER_CREATE | GLOBAL_MODAL_TYPE.BANNER_DISABLE
    size: ModalSize
    hasIcon?: boolean
    isClosable?: boolean
}

const ConfirmModal: React.FC<ExportModalProps> = ({
    title,
    description,
    onConfirm,
    confirmText,
    cancelText,
    modalType,
    size = 's',
    hasIcon = true,
    isClosable = true,
}) => {
    const dispatch = useDispatch()
    const isModalOpen = useSelector(selectIsModalOpen(modalType))

    const onCloseModal = useCallback(() => dispatch(closeModal()), [])

    return isModalOpen ? (
        <Modal
            title={title}
            subtext={description}
            size={size}
            hasIcon={hasIcon}
            primaryButtonProps={{
                label: confirmText,
            }}
            secondaryButtonProps={{
                label: cancelText,
            }}
            onConfirm={onConfirm}
            onClose={onCloseModal}
            isClosable={isClosable}
        />
    ) : null
}

export default ConfirmModal
